<template>
  <div class="close_button" :class="type">
    <div class="inner">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.707031 23.334L23.3344 0.706568"
          stroke="#27363C"
          stroke-width="2"
        />
        <path
          d="M0.707031 0.707031L23.3344 23.3344"
          stroke="#27363C"
          stroke-width="2"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    type: {},
  },

  computed: {},

  watch: {},

  methods: {},

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.close_button {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s ease all;

  /* &.grey {
		.inner {
			background: var(--dark-charcoal);
		}
	} */

  @media (max-width: $mobile-xl) {
    width: 24px;
    height: 24px;
  }

  .inner {
    /* border: var(--border); */
    width: 24px;
    height: 24px;
    /* border-radius: 50%;
		background: var(--bright-blue);
		transition: 0.2s ease all; */
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      /* width: 32px;
			height: 32px;
			transition: 0.2s ease all; */
      cursor: pointer;
    }

		svg {
			width: 18px;
      height: 18px;

			path {
				stroke: var(--fpe-blue);
			}
		}

    img {
      width: 18px;
      height: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/CloseButton.vue